<template>
  <div id="contenedor-configuracion-plantilla-nueva">
    <v-form
      v-model="formularioValido"
      ref="registrarNuevaPlantilla">
      <v-card>
        <v-card-title>
          Nueva Plantilla
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12">
              <v-file-input
                v-model="archivoAnexo"
                outlined
                prepend-icon="mdi-paperclip"
                label="Seleccionar plantilla"
                @change="plantillaSeleccionada"
                hide-details>
              </v-file-input>
            </v-col>
            <text-field
              v-model="plantilla.nombre"
              label="Nombre"
              :rules="[mixReglas.requerido]">
            </text-field>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            label="Cancelar"
            tipo="formCancelar"
            @click="cerrar">
          </custom-button>
          <custom-button
            label="Guardar"
            tipo="formAceptar"
            :disabled="!formularioValido"
            @click="guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import TextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixConfiguracionPlantillas from './mixConfiguracionPlantillas';

export default {
  name: 'ConfiguracionPlantillasNueva',
  mixins: [mixConfiguracionPlantillas],
  components: {
    TextField,
    CustomButton,
  },
  props: {
    modulo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      archivoAnexo: null,
      plantilla: {
        modulo: this.modulo,
        nombre: '',
        path: '',
      },
    };
  },
  methods: {
    limpirarFormulario() {
      this.$refs.registrarNuevaPlantilla.reset();
      this.plantilla.path = '';
    },
    plantillaSeleccionada() {
      if (!this.archivoAnexo) return;
      const nombre = this.archivoAnexo.name.split('.').slice(0, -1).join('.');
      this.plantilla.nombre = nombre;
    },
    cerrar() {
      this.limpirarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
